import React, { useEffect, useState } from "react";
import "../../style.css";
import { Box, Grid, Typography, Pagination, Tooltip, IconButton, Chip, LinearProgress } from "@mui/material";
// import { getAllProjects } from "../Services/api/projectService";
import { useProjectApiClient } from "../Services/api/projectService"

import sampleImage from "../../assets/images/sample-image.png";
import { useLoader } from "../../pages/LoaderContext";
import { API } from "../../backend";
import { ContentCopy, DeleteOutline, ModeEditOutlineOutlined, FileUploadOutlined, CloudDownloadOutlined, FileDownloadOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import LowRiskIcon from "../../assets/images/Low.png";
import MediumRiskIcon from "../../assets/images/medium.png";
import HighRiskIcon from "../../assets/images/high.png";
import CopyProjectModal from "./CopyProjectModal";
import { useAppContext } from '../../hooks/context/AppContext';
import "./gridlist.css";
import { ToastContainer } from "react-toastify";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import { successToast } from "../utils/toast";
import alertIcon from "../../assets/images/alert.png";
import bulbIcon from "../../assets/images/bulb-light-icon.svg";
import { projectVersion } from "config/navConfig";


interface Project {
  id: number;
  project_key: string;
  Project_Id: string;
  name: string;
  category: string;
  ProjectStatus: string;
  Bigbetvalue: string;
  Risk: string;
  Launch_Year: string;
  Launch_MonthName: string;
  Launch_Week: string;
  sclead: string;
  upload_pic: string;
  country_key?: number;
  country?: string;
  brand?: string;
  Launch_QuarterName?: string;
  Module_Completion_Count?: string;
  category_Key?: string;
  subcategory_key?: string;
  brand_key?: string;
  issaved?: boolean;
  project_attributes?: {
    toSaveMileStone?: boolean;
    brand?: string;
    Launch_Year?: string;
    Launch_QuarterName?: string;
  }[];
}

interface ProjectsGridProps {
  selectedFilter: string;
  filters: Record<string, string>;
}

interface Permissions {
  CanRead: boolean;
  CanView: boolean;
  CanCopy: boolean;
  CanDelete: boolean;
  CanEdit: boolean;
  CanCreate: boolean;
  CanSoftDelete: boolean;
}

interface User {
  Email: string;
  FullName: string;
  Role: string;
  module: string;
  permissions: Permissions;
}


export default function ProjectsGrid({ selectedFilter, filters }: ProjectsGridProps) {
  const { getAllProjects, removeProject } = useProjectApiClient();
  const { userData } = useAppContext();
  const [projects, setProjects] = useState<Project[]>([]);
  const [user, setUser] = useState<User | null>(null);
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage] = useState<number>(12);
  const [totalProjects, setTotalProjects] = useState<number>(0);
  const { setLoading } = useLoader();
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [selectedProject, setSelectedProject] = useState<Project | null>(null);
  const [, setViewType] = useState("grid");
  const [openConfirm, setOpenConfirm] = useState(false);
  const [selectedItem, setSelectedItem] = useState('');
  localStorage.removeItem("ProjectDetails"); // Clear ProjectDetails from localStorage
  localStorage.removeItem("project_key"); // Clear project_key from localStorage
  useEffect(() => {
    if (userData) {
      // @ts-ignore
      setUser(userData)
      setViewType("grid")
    }

  }, [userData]);


  const fetchProjects = async () => {
    setLoading(true);
    try {
      let issaved = selectedFilter === "saved" ? 1 : selectedFilter === "draft" ? 0 : undefined;
      // console.log("Fetching projects with:", { selectedFilter, issaved, filters });
      const data = await getAllProjects(page + 1, rowsPerPage, issaved, filters);
      // @ts-ignore
      setProjects(data.projects); setTotalProjects(data.totalProjects);
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProjects();
  }, [page, rowsPerPage, selectedFilter, filters]);



  const handleView = (project: Project) => {
    // console.log("View:", project);
  };

  const getRiskIcon = (risk: string | undefined) => {
    switch (risk?.toLowerCase()) {
      case "low":
        return <img src={LowRiskIcon} alt="Low Risk" style={{ width: 30, height: 16 }} />;
      case "medium":
        return <img src={MediumRiskIcon} alt="Medium Risk" style={{ width: 30, height: 16 }} />;
      case "high":
        return <img src={HighRiskIcon} alt="High Risk" style={{ width: 30, height: 16 }} />;
      default:
        return <img src={LowRiskIcon} alt="Default Risk" style={{ width: 30, height: 16, opacity: 0.5 }} />;
    }
  };

  const handleCopyClick = (project: Project) => {
     console.log("Testttttt", project)
    setSelectedProject(project);
    setOpenModal(true);
  };
  const handleDeleteClick = (project: Project) => {
    console.log("handleDeleteClick", project.Project_Id);
    setSelectedItem(project.Project_Id);
    setOpenConfirm(true);
  };

  const handleConfirmDelete = async () => {
    if (!selectedItem) return;
    try {
      setLoading(true);
      const res = await removeProject(selectedItem);
      setOpenConfirm(false); // Close popup after delete
      fetchProjects(); // Optional: Refresh project list after deletion 
      successToast(res.message)
      setLoading(false);
    } catch (error) {
      console.error("Failed to delete project:", error);
      setLoading(false);
    }
  };


  const handleCancelDelete = () => {
    setOpenConfirm(false);
  };

  return (
    <><ToastContainer />
      <div className="project-tileview">
        <Box sx={{ width: "100%" }}>
          <Box sx={{ padding: "20px" }}>
            {projects.length === 0 ? (
              <Typography variant="h6" align="center">No projects found</Typography>
            ) : (
              <Grid container spacing={2}>
                {projects.map((val) => (
                  
                  <Grid item xs={12} md={2} xl={2} key={val.project_key}>
                    <div className={`projectTypeTrianggle ${val.issaved ? 'SavedTriangle' : 'DraftTriangle'}`}></div>
                    <div className="grid-column-boxes">
                      <Box sx={{ display: "flex", gap: 1 }}>

                        <Tooltip title="Edit">
                          <IconButton
                            disabled={user?.permissions?.CanEdit === true ? false : true}
                            size="small" onClick={() => navigate(`${projectVersion}/project/project-info/${val.Project_Id}/${val.project_key}`)}>
                            <ModeEditOutlineOutlined fontSize="small" />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Upload">
                          <IconButton
                            disabled={user?.permissions?.CanEdit === true ? false : true}
                            size="small" onClick={() => navigate(`${projectVersion}/project/project-info/${val.Project_Id}/${val.project_key}?isUpload=true&moduleId=${1}`)}>
                            <FileUploadOutlined fontSize="small"/>
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Download">
                          <IconButton
                            disabled={user?.permissions?.CanEdit === true ? false : true}
                            size="small" onClick={() => window.open(`${process.env.REACT_APP_BACKEND_V2}/projects/export/${val.project_key}`, "_blank")}><FileDownloadOutlined fontSize="small" />
                          </IconButton>
                        </Tooltip>                        

                        <Tooltip title="Copy">
                          <IconButton
                            disabled={user?.permissions?.CanCopy === true ? false : true}
                            size="small" onClick={() => handleCopyClick(val)}>
                            <ContentCopy fontSize="small" />
                          </IconButton>
                        </Tooltip>


                        <Tooltip title="Delete">
                          <IconButton
                            disabled={user?.permissions?.CanSoftDelete === true ? false : true}
                            size="small"
                            onClick={() => handleDeleteClick(val)}
                          >
                            <DeleteOutline fontSize="small"/>
                          </IconButton>
                        </Tooltip>
                      </Box>
                      <div className="clear"></div>
                      <Box sx={{ p: 2, position: 'relative', marginTop: '-10px', minHeight: '410px' }} className="tileBoxwidget">
                        {/* Icons for Copy, Edit, and View */}

                        <Box>
                          {/* @ts-ignore */}
                          <LinearProgress variant="determinate" value={val?.Module_Completion_Count ? (val?.Module_Completion_Count / 9) * 100 : 0}
                            sx={{
                              my: 2,
                              height: 3,
                              borderRadius: 5,
                              backgroundColor: '#f0f0f0',
                              '& .MuiLinearProgress-bar': {
                                borderRadius: 5,
                                backgroundColor: '#005EEE',
                              },

                            }}
                          />

                        </Box>
                        <div className='product-img-items'>
                          <img
                            src={val?.upload_pic ? val.upload_pic : sampleImage}
                            alt="{}"
                            onError={(e) => e.currentTarget.src = sampleImage}
                          />
                        </div>
                        <div className='product-info'>
                          <h3
                            className="title-product-wt"
                            style={{ cursor: "pointer", color: "#1A3B8B" }}
                            onClick={() => navigate(`${projectVersion}/project/project-info/${val.Project_Id}/${val.project_key}`)}
                          >

                            <Tooltip title={val.name}>
                              <div>
                                {val.name.length < 15 ? val.name : `${val.name.slice(0, 15)}...`}
                              </div>
                            </Tooltip>

                          </h3>

                          <p className="content-txt-inf">
                            {(() => {
                              const category = val.category ?? '';
                              const brand = val.project_attributes?.find(attr => attr.toSaveMileStone)?.brand || 'N/A';

                              const hasValue = category !== '' || brand !== ''; // keep "0" visible
                              const fullText = [category, brand].filter(v => v !== '').join(' - ');

                              if (!hasValue) {
                                return <span className="na-text">N/A</span>;
                              }

                              if ((category.length + brand.length) < 20) {
                                return fullText;
                              }

                              const shortCategory = category.slice(0, 12);
                              const shortBrand = brand.slice(0, 5);
                              const shortText = [shortCategory, shortBrand].filter(Boolean).join(' - ');

                              return (
                                <Tooltip title={fullText}>
                                  <div>{shortText + '...'}</div>
                                </Tooltip>
                              );
                            })()}
                          </p>




                          <span className='content-txt-inf'>Big Bet: {val.Bigbetvalue}</span>
                          <span className='content-txt-inf'>
                            Risk: {getRiskIcon(val.Risk)}
                          </span>
                          <Grid container className='product-cht-items'>
                            <Grid item xs={4}>
                              <h4 className='prdt-sm-tt'>Year</h4>
                              {val.project_attributes?.find(project_attributes => project_attributes.toSaveMileStone)?.Launch_Year || 'N/A'}
                            </Grid>
                            {/* 
                          <Grid item xs={4}>
                            <h4 className='prdt-sm-tt'>Month</h4>
                            <span className='ttl-prt'>{val.Launch_MonthName || 'N/A'}</span>
                          </Grid> 
                          */}

                            <Grid item xs={4}>
                              <h4 className='prdt-sm-tt'>Quarter</h4>
                              <span className='ttl-prt'>
                                {val.project_attributes?.find(attr => attr.toSaveMileStone)?.Launch_QuarterName || 'N/A'}
                                </span>
                            </Grid>
                          </Grid>

                          <p className='content-txt-inf'>SC Lead: {val.sclead}</p>
                        </div>
                      </Box>
                    </div>
                  </Grid>
                ))}
              </Grid>
            )}
          </Box>

          <Box sx={{ display: "flex", justifyContent: "right", padding: "20px" }}>
            <Typography sx={{ fontSize: 12, color: "blue", fontWeight: 600 }}>
              Total Projects <Chip label={totalProjects} color="primary" sx={{ marginLeft: 1 }} />
            </Typography>
            <Pagination
              count={Math.ceil(totalProjects / rowsPerPage)}
              page={page + 1}
              onChange={(_, newPage) => setPage(newPage - 1)}
              siblingCount={1}
              boundaryCount={1}
              showFirstButton
              showLastButton
            />
          </Box>

        </Box>
        {selectedProject && (
          <CopyProjectModal
            open={openModal}
            onRefresh={fetchProjects}
            onClose={() => setOpenModal(false)}
            projectName={selectedProject.name}
            projectId={selectedProject.Project_Id}
            projectKey={selectedProject.project_key}
            existingCountry={selectedProject.country || ""}
            imageName={selectedProject.upload_pic}
            category_Key={selectedProject.category_Key ?? ""}
            subcategory_key={selectedProject.subcategory_key ?? ""}
            brand_key={selectedProject.brand_key ?? ""}
          />
        )}
      </div>
      <Dialog
        open={openConfirm}
        onClose={handleCancelDelete}
      >
        <DialogTitle>
          <h3 className="modal-title">Delete Confirmation</h3>
        </DialogTitle>
        <hr></hr>
        <DialogContent>
          <div className="save-card-wapper">

            <div className="alert-icon-wp">
              <img src={alertIcon} alt="" />
            </div>
            <h2 className="title-save-frm"></h2>
            <div className="txt-flex--mt">
              <span className="bulb-txt"><img src={bulbIcon} alt="" /></span>
              <p> Are you sure you want to delete this item? It will no longer appear in project list.</p>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button className="btn-cancel" onClick={handleCancelDelete} color="primary">
            Cancel
          </Button>
          <Button className="btn-delete" onClick={handleConfirmDelete} color="error" variant="contained">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
